import React, { useEffect, useMemo, useState } from "react";
import InternalHeader from "../InternalPages/InternalHeader";
import { Box, Button, Card, Typography, useMediaQuery } from "@mui/material";
import { useSelector, useDispatch } from "react-redux";
import ForumFilter from "./ForumFilter";
import useThemeRender from "../../theme/useThemeRender";
import { useNavigate } from "react-router-dom";
import { BASE_URL } from "../../constant/apiUrl";
import { getAPI, patchAPI } from "../../API/ApiService";
import Loading from "../../utils/Loader";
import {
  setForumData,
  setFritoCountry,
  setFritoLanguage,
  setFritoSearch,
  setFritoSector,
  setFritoSubject,
} from "../../slices/fritoForumPageSlice";
import { showErrorToast } from "../../utils/Toast/toast";
import LazyImage from "../../utils/LazyImage";
import CustomPagination from "../PotatoProtection/LargeScreen/Landing/CustomPagination";
import NoRecordFounds from "../../utils/NoRecordsFound";

function FritoForumMainPage() {
  const isMobile = useMediaQuery("(max-width: 600px)");
  const isMedium = useMediaQuery("(min-width:600px) and (max-width:1300px)");
  const width = isMobile ? "100%" : isMedium ? "45%" : "30%";
  const insideCardBackgroundColorLayer1 = useThemeRender(
    "insideCardBackgroundColorLayer1"
  );

  const textColorLayer2 = useThemeRender("textColorLayer2");
  const textColorLayer5 = useThemeRender("textColorLayer5");
  const boxShadowlayerColor1 = useThemeRender("boxShadowlayerColor1");
  const insideCardBackgroundColorLayer6 = useThemeRender(
    "insideCardBackgroundColorLayer6"
  );
  const [loading, setLoading] = useState(true);
  const [search, setSearch] = useState("");
  const backgroundColorLayer2 = useThemeRender("backgroundColorLayer2");
  const [page, setPage] = useState(0);
  const itemsPerPage = 9;

  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [filterData, setFilterData] = useState([]);
  const { fritoSector, fritoCountry, fritoLanguage, fritoSubject, forumData } =
    useSelector((state) => state.fritoForumPage);

  function filterContent(
    documents,
    search = "",
    fritoSector = null,
    fritoCountry = null,
    fritoLanguage = null,
    fritoSubject = null
  ) {
    const searchText = search?.toLowerCase() || "";
    const matchesFilters = (item) => {
      const matchesSearch = Object.values(item).some((value) =>
        String(value).toLowerCase().includes(searchText)
      );
      const matchesCountry =
        !fritoCountry ||
        item.countries?.some(
          (country) => country.toLowerCase() === fritoCountry.toLowerCase()
        );
      const matchesSector =
        !fritoSector ||
        item.sectors?.some(
          (sector) => sector.toLowerCase() === fritoSector.toLowerCase()
        );

      const matchesLanguage =
        !fritoLanguage ||
        item.languages?.some(
          (language) => language.toLowerCase() === fritoLanguage.toLowerCase()
        );

      const matchesSubject =
        !fritoSubject ||
        item.subjects?.some(
          (subject) => subject.toLowerCase() === fritoSubject.toLowerCase()
        );

      return (
        matchesSearch &&
        matchesCountry &&
        matchesSector &&
        matchesLanguage &&
        matchesSubject
      );
    };
    const filteredDocuments = documents?.filter(matchesFilters);
    if (JSON.stringify(filteredDocuments) !== JSON.stringify(filterData)) {
      setFilterData(filteredDocuments);
      setPage(0);
    }
  }
  const handleNavigate = async (item) => {
    const contentId = item?.id;

    try {
      await patchAPI(`${BASE_URL}/forum/increment-view-count/${contentId}`, {});
    } catch (err) {
      showErrorToast(err.message);
    } finally {
      navigate(`/frito-forum-detail-page/${item.id}`, { state: item });
    }
  };
  useEffect(() => {
    filterContent(
      forumData,
      search,
      fritoSector?.label,
      fritoCountry?.label,
      fritoLanguage?.label,
      fritoSubject?.label
    );
  }, [
    forumData,
    fritoSector,
    search,
    fritoCountry,
    fritoLanguage,
    fritoSubject,
  ]);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await getAPI(`${BASE_URL}/forum/find-all`);
        if (response?.status === 200) {
          setFilterData(response?.data?.response);
          const fetch = response?.data?.response;
          dispatch(setForumData(fetch));
        }
      } catch (err) {
        showErrorToast(err?.message);
      } finally {
        setLoading(false);
        dispatch(setFritoSector(""));
        dispatch(setFritoCountry(""));
        dispatch(setFritoLanguage(""));
        dispatch(setFritoSearch(""));
        dispatch(setFritoSubject(""));
      }
    };
    fetchData();
  }, [dispatch]);
  const totalPages = useMemo(() => {
    const total = Math.ceil(filterData.length / itemsPerPage);
    return total > 0 ? total : 1; // Ensure at least 1 page exists
  }, [filterData.length, itemsPerPage]);
  const paginatedRows = useMemo(() => {
    return filterData.slice(page * itemsPerPage, (page + 1) * itemsPerPage);
  }, [filterData, page, itemsPerPage]);
  const handleSearch = (value) => {
    setSearch(value);
    setPage(0);
  };
  if (loading) return <Loading />;
  return (
    <Box
      sx={{
        mt: "16px",
        display: "flex",
        flexDirection: "column",
        gap: "24px",
        paddingX: { xs: "16px", md: "50px" },
        marginBottom: "2rem",
      }}
    >
      <InternalHeader header={"Frito forum"} />
      <Box sx={{ zIndex: 1000 }}>
        <ForumFilter handleSearch={handleSearch} />
      </Box>

      <Card
        sx={{
          display: "flex",
          padding: "var(--Spacing-spacing-24, 24px)",
          alignItems: "flex-start",
          alignContent: "flex-start",
          gap: "24px var(--Spacing-spacing-24, 24px)",
          borderRadius: "var(--Corner-radius-effect-corner-2, 8px)",
          background: backgroundColorLayer2,
          boxShadow:
            "var(--Elevation-X-Elevation-01, 0px) var(--Elevation-Y-Elevation-01, 0px) var(--Elevation-Blur-Elevation-01, 24px) var(--Elevation-Spread-Elevation-01, 0px) var(--Elevation-Colors-Elevation-01, rgba(0, 92, 188, 0.08))",
          flexWrap: "wrap",
        }}
      >
        {paginatedRows?.map((item) => (
          <Card
            sx={{
              width: width,
              flex: "0 0 auto",
              boxShadow: `0px 0px 24px 0px ${boxShadowlayerColor1}`,
              borderRadius: "0px",
              background: "000",
            }}
            key={item.id}
          >
            <Box
              sx={{
                display: "flex",
                padding: isMobile ? "8px" : "var(--Spacing-spacing-16, 16px)",
                flexDirection: "column",
                alignItems: "flex-start",
                gap: "var(--Spacing-spacing-16, 16px)",
                borderRadius: "var(--Corner-radius-corner-radius-small, 8px)",
                // boxShadow:
                //   "var(--Elevation-X-Elevation-01, 0px) var(--Elevation-Y-Elevation-01, 0px) var(--Elevation-Blur-Elevation-01, 24px) var(--Elevation-Spread-Elevation-01, 0px) var(--Elevation-Colors-Elevation-01, rgba(0, 92, 188, 0.08))",
                background: insideCardBackgroundColorLayer1,
                boxShadow: "none",
                border: "1px solid #D7E5F8",
              }}
            >
              <Box
                sx={{
                  display: "flex",
                  padding: "var(--Spacing-spacing-0, 0px)",
                  flexDirection: "column",
                  alignItems: "flex-start",
                  gap: "var(--Spacing-spacing-12, 12px)",
                  alignSelf: "stretch",
                }}
              >
                <LazyImage url={item?.cdnUrl} />
              </Box>
              <Box
                sx={{
                  display: "flex",
                  flexDirection: "column",
                  alignItems: "flex-start",
                  gap: "var(--Spacing-spacing-8, 8px)",
                  alignSelf: "stretch",
                  height: "auto",
                }}
              >
                <Typography
                  variant="h5"
                  sx={{
                    color: textColorLayer2,
                    fontFeatureSettings: "'liga' off, 'clig' off",
                    fontFamily: "var(--Typography-Font-Family-Heading, Inter)",
                    fontSize: isMobile ? "18px" : "var(--Font-Size-H5, 24px)",
                    fontStyle: "normal",
                    fontWeight: 700,
                    lineHeight: "var(--Line-Height-H5, 32px)",
                    alignSelf: "stretch",
                    minHeight: "64px", // 2 lines * lineHeight (32px)
                    maxHeight: "64px",
                    overflow: "hidden", // Hides overflowing content
                    textOverflow: "ellipsis", // Adds ellipsis
                    display: "-webkit-box", // Required for multiline ellipsis
                    WebkitBoxOrient: "vertical", // Required for multiline ellipsis
                    WebkitLineClamp: 2, // Limit to 2 lines
                  }}
                >
                  {item?.title}
                </Typography>
                <Typography
                  sx={{
                    color: textColorLayer2,
                    fontFeatureSettings: "'liga' off, 'clig' off",
                    fontFamily: "var(--Typography-Font-Family-Body, Inter)",
                    fontSize: "var(--Font-Size-Body, 16px)",
                    fontStyle: "normal",
                    fontWeight: 500,
                    lineHeight: "var(--Line-Height-Body, 22px)",
                    minHeight: "64px", // 2 lines * lineHeight (32px)
                    maxHeight: "64px",
                    overflow: "hidden", // Hides overflowing content
                    textOverflow: "ellipsis", // Adds ellipsis
                    display: "-webkit-box", // Required for multiline ellipsis
                    WebkitBoxOrient: "vertical", // Required for multiline ellipsis
                    WebkitLineClamp: 2, // Limit to 2 lines
                  }}
                >
                  {item?.description}
                </Typography>
                <Typography
                  style={{
                    color: textColorLayer5,
                    fontFamily: "var(--Typography-Font-Family-Body, Inter)",
                    fontSize: "var(--Font-Size-Body, 16px)",
                    fontStyle: "normal",
                    fontWeight: 700,
                    lineHeight: "var(--Line-Height-Body, 22px)",
                  }}
                >
                  Subjects
                </Typography>
                <Box
                  style={{
                    display: "flex",
                    alignItems: "center",
                    gap: "12px",
                    height: "auto",
                    flexWrap: "wrap", // <--- allows items to wrap
                    minHeight: "64px",
                    maxHeight: "64px",
                  }}
                >
                  {item?.subjects?.slice(0, 2)?.map((val, index) => (
                    <Box
                      sx={{
                        display: "flex",
                        padding:
                          "var(--Spacing-spacing-4, 4px) var(--Spacing-spacing-02, 4px)",
                        alignItems: "center",
                        gap: "2px",
                        borderRadius:
                          "var(--Corner-radius-effect-corner-1, 4px)",
                        background: insideCardBackgroundColorLayer6,
                      }}
                      key={item.id}
                    >
                      <Typography
                        sx={{
                          color: textColorLayer2,
                          fontFeatureSettings: "'liga' off, 'clig' off",
                          fontFamily: "Inter",
                          fontSize: "12px",
                          fontStyle: "normal",
                          fontWeight: 400,
                          lineHeight: "133%",
                          overflow: "hidden", // Hides overflowing content
                          textOverflow: "ellipsis", // Adds ellipsis
                          display: "-webkit-box", // Required for multiline ellipsis
                          WebkitBoxOrient: "vertical", // Required for multiline ellipsis
                          WebkitLineClamp: 1, // Limit to 2 lines
                        }}
                      >
                        {val}
                      </Typography>
                    </Box>
                  ))}
                  {item?.subjects?.length > 3 && (
                    <Box
                      sx={{
                        display: "flex",
                        padding:
                          "var(--Spacing-spacing-4, 4px) var(--Spacing-spacing-02, 4px)",
                        alignItems: "center",
                        gap: "2px",
                        borderRadius:
                          "var(--Corner-radius-effect-corner-1, 4px)",
                        background: insideCardBackgroundColorLayer6,
                      }}
                    >
                      <Typography
                        sx={{
                          color: textColorLayer2,
                          fontFeatureSettings: "'liga' off, 'clig' off",
                          fontFamily: "Inter",
                          fontSize: "12px",
                          fontStyle: "normal",
                          fontWeight: 400,
                          lineHeight: "133%",
                        }}
                      >
                        +{item?.subjects?.length - 2} more
                      </Typography>
                    </Box>
                  )}
                </Box>
                <Box
                  sx={{
                    display: "flex",
                    justifyContent: "end",
                    alignItems: "center",
                    width: "100%",
                  }}
                  onClick={() => handleNavigate(item)}
                >
                  <Button
                    sx={{
                      display: "flex",
                      height: "var(--Spacing-spacing-32, 32px)",
                      width: "142px",
                      justifyContent: "center",
                      flexDirection: "row",
                      alignItems: "center",
                      gap: "4px",
                      borderRadius:
                        "var(--Corner-radius-corner-radius-large, 24px)",
                      border:
                        "var(--Border-border-1, 1px) solid var(--Tokens-Button-Outlined, #005CBC)",
                    }}
                  >
                    <Typography
                      sx={{
                        color: "#005CBC",
                        fontWeight: 700,
                        fontSize: "14px",
                        textTransform: "none",
                      }}
                    >
                      View Details
                    </Typography>
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="14"
                      height="14"
                      viewBox="0 0 14 14"
                      fill="none"
                    >
                      <path
                        d="M6.99998 0.333008L5.82498 1.50801L10.475 6.16634H0.333313V7.83301H10.475L5.82498 12.4913L6.99998 13.6663L13.6666 6.99967L6.99998 0.333008Z"
                        fill="#005CBC"
                      />
                    </svg>
                  </Button>
                </Box>
              </Box>
            </Box>
          </Card>
        ))}
        {filterData?.length > 0 && (
          <Box
            sx={{
              display: "flex",
              justifyContent: "center",
              marginTop: "16px",
              width: "100%",
            }}
          >
            <CustomPagination
              page={page}
              setPage={setPage}
              totalPages={totalPages}
            />
          </Box>
        )}
        <div className="m-auto">
          {filterData.length == 0 && <NoRecordFounds />}
        </div>
      </Card>
    </Box>
  );
}

export default FritoForumMainPage;
